import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import InitializationServiceOmnicom from 'omnicom/classes/InitializationService'
import { wsConnectionPool } from 'src/core/classes/ws/WSConnectionPool'
import { CoreLoaderWrapper, ILoader } from 'src/core/components/app/loaders'

export const AppLoaderWrapper = ({ children, ...props }: ILoader) => {
  const user = useSelector(selectUser)

  const beforeInitCallback = useCallback(() => {
    wsConnectionPool.initWSPool(import.meta.env.VITE_WS_SERVERS)

    InitializationServiceOmnicom.init(user)
  }, [user])

  return (
    <CoreLoaderWrapper {...props} beforeInitCallback={beforeInitCallback}>
      {children}
    </CoreLoaderWrapper>
  )
}
